function sortStatusEntries(dialogues, sortBy, direction) {
  if (!dialogues) {
    return [];
  }
  return dialogues.sort((a, b) => {
    const start = direction === "asc" ? a : b;
    const end = direction === "asc" ? b : a;
    switch (sortBy) {
      case "date":
        return start.createdAt.getTime() - end.createdAt.getTime();
      case "title":
        return start.title.localeCompare(end.title);
    }
  });
}

export { sortStatusEntries };
//# sourceMappingURL=util.sort.js.map
